import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import { createPinia } from "pinia";
import "@vueup/vue-quill/dist/vue-quill.snow.css"; // スタイルのインポート
import VueGtm from "vue-gtm";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";

// 環境変数から GTM の ID を取得
const GTM_ID = process.env.VUE_APP_GTM_ID;
const app = createApp(App);
const pinia = createPinia();

// GTM を Vue アプリに統合
app.use(VueGtm, {
  id: GTM_ID, // GTM の ID
  vueRouter: router, // Vue Router のページ遷移を自動トラッキング
  enabled: true, // 本番環境では true, 必要に応じて制御
  debug: process.env.NODE_ENV === "development", // 開発環境でデバッグログを表示
  loadScript: false, // `index.html` で GTM を読み込むため `false` に設定
});

app.config.errorHandler = (err, vm, info) => {
  // エラーログをコンソールに出力
  console.error(`Global error handler: Error: ${err}, Info: ${info}`);

  // オプション：エラー情報を外部ログサービスに送信
  // sendErrorToService(err, vm, info);

  // オプション：ユーザーにエラーが発生したことを知らせる
  alert("エラーが発生しました。システム管理者にお問い合わせください。");
  const error = err as Error;

  const errorDetails = {
    message: error.message,
    stack: error.stack,
    componentInfo: info,
    userAgent: navigator.userAgent,
  };

  sendErrorToServer(errorDetails);

  // エラーページや特定のエラービューにリダイレクト
  router.push("/error-page").catch((error) => {
    // ルートエラーが発生した場合の処理
    console.error(`Router navigation error: ${error}`);
  });
};

// systemKbn を環境変数から取得
const systemKbn = process.env.VUE_APP_SYSTEM_KBN;

if (systemKbn === "01") {
  import("@/assets/common/css/style.css");
} else if (systemKbn === "02") {
  import("@/assets/common/css/style02.css");
} else if (systemKbn === "03") {
  import("@/assets/common/css/style03.css");
} else {
  import("@/assets/common/css/style.css"); // デフォルト
}

// if (systemKbn === "01") {
//   // ウィズ
//   require("@/assets/common/css/style.css");
// } else if (systemKbn === "02") {
//   // ベース
//   require("@/assets/common/css/style02.css");
// } else if (systemKbn === "03") {
//   // 卸
//   require("@/assets/common/css/style03.css");
// } else {
//   require("@/assets/common/css/style.css"); // デフォルト
// }

app.use(store).use(router).use(pinia).use(FloatingVue).mount("#app");

function sendErrorToServer(errorDetails: any) {
  const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
  axios
    .post(`${apiBaseUrl}/api/errorlog`, errorDetails)
    .then((response) => console.log("Error logged on server"))
    .catch((error) => console.error("Failed to log error:", error));
}
